module.exports = __webpack_public_path__ + "img/merk.5153914f.jpg";